import { Icon } from '@advanza/ui'
import { useAppSelector } from 'hooks/hooks'
import React from 'react'

const ProspectLabel = ({ providerId, provider: providerProp, emptyValue = '-', fontSize = 12 }) => {
    const { providers } = useAppSelector((state) => state.providers?.entities || {})
    const provider = providerProp || (providers && providers[providerId])

    if (!provider || !provider.office_labels || !Array.isArray(provider.office_labels)) {
        return <div>{emptyValue}</div>
    }

    const prospectLabel = provider.office_labels.filter(({ type }) => type === 'prospect')[0]
    if (!prospectLabel) {
        return <div>{emptyValue}</div>
    }

    const isNew = prospectLabel.description && prospectLabel.description.includes('*')
    return (
        <div
            style={{ cursor: 'help', whiteSpace: 'nowrap' }}
            title={`${prospectLabel && prospectLabel.description} prospect value ${
                isNew ? '(no data)' : ''
            }`}>
            {prospectLabel
                ? prospectLabel.description
                      .split('')
                      .map((i, it) => (
                          <Icon
                              style={{ color: isNew ? 'gray' : 'goldenrod' }}
                              fontSize={fontSize}
                              key={it}
                              name="euro_symbol"
                          />
                      ))
                : emptyValue}
        </div>
    )
}

export default ProspectLabel
